import request from '@/utils/ai-train-request'
import { getToken } from '@/utils/auth'

const apiPath = '/admin/trial'
export default {
  start(sceneId) { return request({ url: apiPath + '/start', method: 'post', data: { sceneId } }) },
  get(id) { return request({ url: apiPath + '/' + id, method: 'get' }) },
  end(id) { return request({ url: apiPath + '/' + id + '/end', method: 'post', data: { reason: 1 } }) },
  heartbeat(id, visible) { return request({ url: apiPath + '/' + id + '/heartbeat', method: 'post', data: { visible } }) },
  evaluation(id) { return request({ url: apiPath + '/' + id + '/evaluation', method: 'get' }) },
  history(sceneId, page, pageSize) { return request({ url: apiPath + '/history', method: 'get', params: { sceneId, page, pageSize } }) }
}

/** Stream only the dedicated ADMIN preview endpoint, carrying the same token as normal AI admin APIs. */
export function streamTrialChat(id, content, callbacks) {
  const controller = new AbortController()
  const base = process.env.VUE_APP_AI_TRAIN_API
  let ended = false
  async function run() {
    try {
      if (!base) throw new Error('试聊服务暂不可用，请联系管理员')
      const response = await fetch(base.replace(/\/$/, '') + apiPath + '/' + id + '/chat', {
        method: 'POST', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Token: 'DU ' + getToken(), Accept: 'text/event-stream' },
        body: JSON.stringify({ content })
      })
      const type = response.headers.get('content-type') || ''
      if (!response.ok || !type.includes('text/event-stream')) {
        let message = '试聊请求失败，请核对权限和会话状态'
        try { const body = await response.json(); message = body.msg || body.message || message } catch (_) { /* 保留失败提示 */ }
        throw new Error(message)
      }
      if (!response.body) throw new Error('当前浏览器不支持试聊消息流')
      const reader = response.body.getReader()
      const decoder = new TextDecoder('utf-8')
      let buffer = ''
      const parseFrames = () => {
        buffer = buffer.replace(/\r\n/g, '\n')
        let split
        while ((split = buffer.indexOf('\n\n')) >= 0) {
          const frame = buffer.slice(0, split); buffer = buffer.slice(split + 2)
          let event = ''; const lines = []
          frame.split('\n').forEach(line => {
            if (line.startsWith('event:')) event = line.slice(6).trim()
            else if (line.startsWith('data:')) lines.push(line.slice(5).trimStart())
          })
          if (!lines.length) continue
          const data = JSON.parse(lines.join('\n'))
          if (event === 'delta') callbacks.onDelta(data.content || '')
          else if (event === 'done') { ended = true; callbacks.onDone(data); return }
          else if (event === 'error') throw new Error(data.reason || '试聊回复失败，请核对会话后重试')
        }
      }
      try {
        while (!ended) {
          const chunk = await reader.read()
          if (chunk.done) { buffer += decoder.decode(); parseFrames(); break }
          buffer += decoder.decode(chunk.value, { stream: true }); parseFrames()
        }
      } finally { await reader.cancel().catch(() => {}) }
      if (!ended) throw new Error('回复完成状态未确认，请重新读取试聊后再发送')
    } catch (error) {
      if (!ended && error.name !== 'AbortError') callbacks.onError(error.message || '试聊连接失败，请重新读取会话')
    }
  }
  run()
  return { abort() { controller.abort() } }
}
